module.exports = __webpack_public_path__ + "static/media/severance_review.f92c4457.jpg";